import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { ICreatePublicReservation, IPublicReservation } from '../../models/public-reservation';

@Injectable({
	providedIn: 'root',
})
export class PublicReservationProvider extends Provider<IPublicReservation> {
	protected readonly url: string = '/reservations/public';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getOneByExternalId(externalId: string): Promise<IPublicReservation> {
		return this.process(this.api.get(`${this.url}/${externalId}`)) as Promise<IPublicReservation>;
	}

	public getAllOfEventDay(eventId: string, calendarEventId: string): Promise<Array<IPublicReservation>> {
		return this.process(this.api.get(`${this.url}/${eventId}/${calendarEventId}`)) as Promise<
			Array<IPublicReservation>
		>;
	}

	public reserveOrRegisterPublicReservation(
		body: { reservation: ICreatePublicReservation; captchaToken: string },
		eventId: string,
		calendarEventId: string
	): Promise<IPublicReservation> {
		return this.process(
			this.api.post(`${this.url}/${eventId}/${calendarEventId}`, body)
		) as unknown as Promise<IPublicReservation>;
	}
}
